import request from '@/utils/request'

/**
 * @desc 推广人信息
 */
export const simple = () => {
  return request.get('/promoter/simple')
}

